import { isInApp } from '../../utils/helpers/common'

const HeaderSection = ({ data }) => {
  const headerImage = data?.image
  const inApp = isInApp()
  return (
    <>
      <div
        className="w-full sticky top-0 left-0 z-[11] mx-auto"
        style={{
          paddingTop: inApp ? '0px' : 'env(safe-area-inset-top)',
        }}
      >
        <div className="h-[60px] max-h-[60px] overflow-hidden">
          <img
            src={headerImage}
            alt="Header"
            className="w-full h-auto object-scale-down"
          />
        </div>
      </div>
      <div
        className="w-full"
        style={{ height: 'calc(0px + env(safe-area-inset-top))' }}
      />
    </>
  )
}

export default HeaderSection
